import { NoteContentVersion } from "@/store/note/types";

export enum CustomEventName {
  Example = "user-action",
  ShareFailed = "share-failed",
  NoteContentDocumentUpdated = "note-content-document-updated",
  ExpandVoicePopover = "expand-voice-popover",
}

export interface CustomEventMap {
  [CustomEventName.Example]: {
    elementId: string;
    timestamp: number;
  };
  [CustomEventName.ShareFailed]: {
    email: string;
  };
  [CustomEventName.NoteContentDocumentUpdated]: NoteContentVersion;
  [CustomEventName.ExpandVoicePopover]: {
    noteId: string;
  };
}
